import React,{useEffect,useState} from 'react';
import {Link, useNavigate} from 'react-router-dom'
import he from "he"
import Skeleton from '../../pages/skelton';

  


function Card(props) {

             const navigate = useNavigate()
            const {item,index}=props;
            const {content_title,content_url,content_image,short_desc}=item;

    return (
          
                 <div className='devotional-home-content'>
                    <Link to= {content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/'} 
                        className='devotional-home-content-img-anchor'>
                           <img  loading={index === 0 ? 'eager' : 'lazy'}  fetchpriority={index === 0 ? 'hight' : 'auto'}   src={content_image ? content_image : '/devotional/assets/images/error_img.webp'} alt="d-h-c-img" />
                     </Link>
                     <div>
                         <Link className='home-card-title' to={content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/'} >{content_title ? content_title : ""}</Link>
                         <p dangerouslySetInnerHTML={{ __html: short_desc  ?  he.decode(short_desc) : '' }} onClick={() => navigate(content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/') } ></p>
                        {/*<Link to={content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/'}><button type="button" className='devotional-home-view-button' >View » </button></Link>*/}
                     </div>
                 </div>
            
    )
     
}


function MangalCard(props) {

    const {item}=props;
    
    const {content_url,content_image,cat_name}=item;
    



     return (
         <div className='mangalaratulu-card shadow-lg'>
                <h1 className='devotional-home-common-title'>{cat_name ? cat_name : 'category'}
                  <Link to="/videolist/mangalaharathulu-40.html" className='home-more-anchor'>View More</Link>
                </h1>
                <Link to={content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/'} >
                    <img src={content_image ? content_image : '/devotional/assets/images/error_img.webp'} alt="d-h-c-img" />
                </Link>
                {/* <button type="button" className='btn btn-danger' >
                <Link to={content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/devotional'}>More</Link>
                </button> 
                <Link to={content_url ? content_url.substring(content_url.indexOf('/devotional')+11 ) : '/'}><button type="button" className='devotional-home-view-button' >View Video » </button></Link>*/}
                </div>
     )
}
    




function DummyCard() {

     return (
        <div className='container-fluid' >
        <div className='row mt-2 mb-2'>
           <div className='col-3'><Skeleton type={"square"} /></div>
           <div className='col-8'>
              <Skeleton type={"title"} />
              <Skeleton type={"paragraph"} />
              <Skeleton type={"paragraph"} />
              <Skeleton type={"paragraph"} />
              <Skeleton type={"paragraph"} />
              <Skeleton type={"paragraph"} />
              <Skeleton type={"paragraph"} />
              <Skeleton type={"paragraph"} />
           </div>
        </div>
        </div>
     )
}




const DevotionalHomeContentCardSection = ({contentCardsData,contentCardsDataError}) => {

                             const ssrContentsCardsData = contentCardsData ? contentCardsData : null

                              const [data,setData]=useState(ssrContentsCardsData)
                              const [error,setError]= useState(contentCardsDataError);
                              const [loading,setLoading]=useState(!data && !error);


                              
                             



                         
                
                  useEffect(() => {


                  if (ssrContentsCardsData) {
                      
                      setLoading(false)
                      setError(null)
                      return;
                  }


                  else {

                      const getData = async () => {
                          setLoading(true)
                           try {
                  
                            let response=await fetch(`https://www.teluguone.com/devotional_api/devotionalHomeCatsJson`)
                            if (!response.ok) throw new Error('Network response was not ok');
                  
                            let data=await response.json()
                         
                            
                           
                               
                                 setData(data)
                                 setLoading(false)
                                 setError(null)
                      
                  
                            
                           } catch (error) {
                              
                          
                                  setData([])
                                  setLoading(false)
                                  setError(error.message)

                              console.log(error.message)
                           }
                      }
                   
                      getData()


                    }

                  }, [])

   if (loading) {

       return (
       

           <>      {Array(2).fill("A").map((_,index) =>  <DummyCard key={index}   />)}
     {Array(2).fill("A").map((_,index) =>  <DummyCard key={index}   />)}
     {Array(2).fill("A").map((_,index) =>  <DummyCard key={index}   />)}
     {Array(2).fill("A").map((_,index) =>  <DummyCard key={index}   />)}
     </>
        
       )
   }


   if (error) {

    return (
           <div className='devotional-home-content-card shadow-lg'>
               <div className="json-loading-error-div">
               <img   src="/devotional/assets/images/json_error.png" alt="json_error" />
               </div>
           </div>
   )
   }


  return (
    <>
     <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_latest_cat"]?.[0]?.cat_name ? data["home_latest_cat"][0].cat_name : 'category'} 
          <Link to="/newarticles/new-articles.html" className='home-more-anchor'>View More</Link></h1>
             {data && data["home_latest_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>

      <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_enduku_cat"]?.[0]?.cat_name ? data["home_enduku_cat"][0].cat_name : 'category'}
            <Link to="/subpages/enduku-emiti-107.html" className='home-more-anchor'>View More</Link>
          </h1>
             {data && data["home_enduku_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>


      <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_vastu_cat"]?.[0]?.cat_name ? data["home_vastu_cat"][0].cat_name : 'category'}
            <Link to="/subpages/vastu-277.html" className='home-more-anchor'>View More</Link>
          </h1>
             {data && data["home_vastu_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>

      <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_achar_cat"]?.[0]?.cat_name ? data["home_achar_cat"][0].cat_name : 'category'}
             <Link to="/subpages/aacharalu-59.html" className='home-more-anchor'>View More</Link>
          </h1>
             {data && data["home_achar_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>

      <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_myth_cat"]?.[0]?.cat_name ? data["home_myth_cat"][0].cat_name : 'category'}
              <Link to="/subpages/puranapatralu-mythologicalstories-278.html" className='home-more-anchor'>View More</Link>
          </h1>
             {data && data["home_myth_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>

      <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_punk_cat"]?.[0]?.cat_name ? data["home_punk_cat"][0].cat_name : 'category'}
            <Link to="/subpages/punyakshetralu-65.html" className='home-more-anchor'>View More</Link>
          </h1>
             {data && data["home_punk_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>

      <div   className='col-12  col-lg-6'>
          <div className='devotional-home-content-card shadow-lg'>
          <h1 className='devotional-home-common-title'>{data["home_vys_cat"]?.[0]?.cat_name ? data["home_vys_cat"][0].cat_name : 'category'}
             <Link to="/subpages/vyasalu-54.html" className='home-more-anchor'>View More</Link>
          </h1>
             {data && data["home_vys_cat"].map((item,index) =>  <Card key={index} index={index} item={item}  />)}
         </div>
      </div>

   
      <div  className='col-12  col-lg-6'><MangalCard item={data["home_mangal_cat"]?.[0]}   /></div>
    
    </>
  )
}

export default DevotionalHomeContentCardSection;
